<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <div class="container py-4">
            <GoBackButton/>
        </div>

        <ProductModifyItemListTable
            :piw-list="getModifyProductDetails.modifiedProductItems"
        />

    </Row>
</template>

<script>
import GoBackButton from "@/components/GoBackButton.vue";
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import ProductModifyItemListTable from "@/components/ProductModifyItemListTable.vue";
import Row from "@/components/html/Row.vue";

export default {
    name: "InventoryListItem",
    components: {Row, ProductModifyItemListTable, GoBackButton},
    mixins: [currencyFormatMixin],
    computed: {
        ...mapGetters(['getModifyProductDetails'])
    },
    methods: {
        ...mapActions(['fetchModifyProductDetails'])
    },
    mounted() {
        if (this.$route.params.id) {
            this.fetchModifyProductDetails(this.$route.params.id)
        }
    }
}
</script>

<style scoped>

</style>
